import { ListenerOptions, useWindowListener } from './useWindowListener';

interface KeyBoardOptions extends ListenerOptions {
  preserveDefault?: boolean;
}

const EventKeyMap = {
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  Backspace: 'Backspace',
  Delete: 'Delete',
  Enter: 'Enter',
  Escape: 'Escape',
  a: 'a',
  c: 'c',
  i: 'i',
  m: 'm',
  n: 'n',
  p: 'p',
  q: 'q',
  r: 'r',
  t: 't',
  v: 'v',
  x: 'x',
  z: 'z',
};

const ExcludedTags: { [key: string]: string } = {
  INPUT: 'INPUT',
  TEXTAREA: 'TEXTAREA',
  SELECT: 'SELECT',
};

const hasKey = (
  event: Event,
  key: keyof typeof EventKeyMap,
): event is KeyboardEvent => {
  return (
    event instanceof KeyboardEvent &&
    event.key.toLowerCase() === EventKeyMap[key].toLowerCase()
  );
};

export const useKeyboard = <K extends keyof WindowEventMap>(
  eventType: K,
  key: keyof typeof EventKeyMap,
  fn: (arg: KeyboardEvent) => void,
  { preserveDefault, ...options }: KeyBoardOptions = {},
) => {
  const scoped = (event: Event) => {
    if (
      document.activeElement &&
      ExcludedTags[document.activeElement.tagName]
    ) {
      return;
    }

    if (hasKey(event, key)) {
      fn(event);
      preserveDefault && event.preventDefault();
    }
  };

  useWindowListener(eventType, scoped, options);
};
